import {Component} from "react";
import React from "react";
import {withRouter} from "react-router-dom";
import icon_person from '../assets/images/ico_person.png';
import icon_microphone from '../assets/images/microphone.png';
import icon_trafficlight_empty from '../assets/images/trafficlight_empty.png';
import icon_trafficlight_yellow from '../assets/images/trafficlight_yellow.png';
import icon_trafficlight_green from '../assets/images/trafficlight_green.png';
import recButton from "../assets/images/rec.gif";
import TRACKING from "../Shared/DataTrackingPoints";
import Helpers from "../Shared/Helpers";
import RecordRTC from "recordrtc";
import {osName} from "react-device-detect";
import REST from "../Shared/REST";
const NetworkSpeed = require('network-speed');
const testNetworkSpeed = new NetworkSpeed();
let sampleRateHz = 44100;

osName === "Mac OS" ? sampleRateHz = 44100 : sampleRateHz = 48000;

const STEP = {
    HAS_CAMERA: 1,
    HAS_MICROPHONE:2,
    CHECK_NETWORK:3,
    CHECKING_NETWORK:4,
    NETWORK_RESULT:5,
    FINAL_RESULT:6,
    CHECK_VIDEO:7,
    CHECK_AUDIO:8,
    VIDEO_AUDIO_RESULT:9
}

const NETWORK_SPEED = {
    EXCELLENT: 1,
    GOOD: 0.5,
    ACCEPTABLE: 0.1,
    POOR: 0
}

const NETWORK_STATUS = {
    EXCELLENT: 3,
    GOOD: 2,
    ACCEPTABLE: 1,
    POOR: 0,
    CHECKING: -1,
    UNKNOWN: -2
}

const NETWORK_STATUS_STRING = {
    EXCELLENT: "excellent",
    GOOD: "good",
    ACCEPTABLE: "acceptable",
    POOR: "poor",
    UNKNOWN: "unknown"
}

class CheckVideoComponent extends Component{
    constructor(props){
        super(props);
        this.state = {
            checking: false,
            result: false
        }
        this.handleClickCheck=this.handleClickCheck.bind(this);
        this.handleStop=this.handleStop.bind(this);
    }

    handleClickCheck(){
        this.setState({checking: true});
        this.requestUserMedia();
    }

    handleStop(){
        this.releaseStreamFromVideo();
        if(this.state.result){
            this.props.handleStopSuccess();
        }else{
            this.props.handleStopFailure();
        }
    }

    setStreamToVideo(stream) {
        this.video.srcObject = stream;
    }

    releaseStreamFromVideo() {
        this.video.srcObject = null;
    }

    requestUserMedia() {
        console.log('requestUserMedia');
        this.captureUserMedia((stream) => {
            this.setStreamToVideo(stream);
            this.setState({result:true});
        });
    }

    captureUserMedia = (callback, options) => {
        let params = null;
        if(options){
            params = options;
        }else{
            params = {
                audio: false,
                video: Helpers.getVideoSizes()
            };
        }

        navigator.mediaDevices.getUserMedia(params)
            .then(callback)
            .catch(error => {
                this.setState({result:false});
                console.log(error);
            });
    };


    render(){
        return(
            <div>
                <div className="row">
                    <div style={{width:250, marginLeft:'auto',marginRight:'auto', display:'flex'}}>
                        <div>
                            <img src={icon_person} style={{position:'relative',marginBottom:-5,width:65, height: 70}}/>
                        </div>
                        <div style={{marginTop:18, marginLeft:5}}>
                            <h3>Check Webcam</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={"col-md-6 col-sm-6"}>
                        <div style={{marginTop:100, marginLeft:50}}>
                            <p>1. Click the 'Check' button.</p>
                            <p>2. Click 'Allow' if you see a question <br/>
                                in a dialog box</p>
                            <p>3. Your video should show in a few seconds.<br/>
                                If you can see yourself, your video camera is working.</p>
                        </div>
                    </div>
                    <div className={"col-md-6 col-sm-6"}>
                        {this.state.checking === false?
                            <div style={{marginTop: 140, marginLeft:'auto',marginRight:'auto', width:80}}>
                                <a className="handBtn" onClick={this.handleClickCheck}><span>Check</span></a>
                            </div>:
                            <div>
                                <div style={{marginTop: -30, marginLeft:'auto',marginRight:'auto', width:320, height: 220}}>
                                    <video
                                        id={"copyrightVidPlayback"}
                                        playsInline={true}
                                        ref={video => {
                                            this.video = video
                                        }}
                                        style={{position: 'relative', top: 65}}
                                        width="100%"
                                        autoPlay={true}
                                        controls={false}
                                        className={"flippedVideo"}
                                    />
                                </div>
                                <div style={{marginTop: 100, marginLeft:'auto',marginRight:'auto', width:80}}>
                                    <a className="handBtn" onClick={this.handleStop}><span>Stop</span></a>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                </div>
            </div>
        )
    };
}

class CheckAudioComponent extends Component{
    constructor(props){
        super(props);
        this.state = {
            recordAudio: null,
            audioState: 0, //0: none, 1:requesting media, 2: recording, 3: recorded, 5. playing, 6. played.
            result: false
        }
        this.handleClickCheck=this.handleClickCheck.bind(this);
        this.handleStop=this.handleStop.bind(this);
        this.handlePlay=this.handlePlay.bind(this);
        this.handleNext=this.handleNext.bind(this);
    }

    handleClickCheck(){
        this.setState({audioState: 1});
        this.requestUserMedia();
    }

    handleStop(){
        this.state.recordAudio.stop((wavBlob) => {
            this.audio2.src = URL.createObjectURL(wavBlob);
        });
        this.setState({audioState:3});
    }

    handlePlay(){
        this.audio2.play();
    }

    handleNext(){
        this.releaseStreamFromAudio();
        if(this.state.result){
            this.props.handleStopSuccess();
        }else{
            this.props.handleStopFailure();
        }
    }

    releaseStreamFromAudio() {
        this.audio.pause();
        this.audio.srcObject = null;
        this.audio.src = "";
        this.audio.load();
    }

    requestUserMedia() {
        this.captureUserMedia((stream) => {
            let options = {
                type: 'audio',
                audio: this.audio,
                sampleRate: sampleRateHz,
                bufferSize: 4096,
                numberOfAudioChannels: 1,
                recorderType: RecordRTC.StereoAudioRecorder
            };

            this.setState({
                recordAudio: new RecordRTC.StereoAudioRecorder(stream, options),
                result:true,
                audioState:2
            });
            this.state.recordAudio.record();
            this.setState({result:true});
        }, {audio: true, video: false});
    }

    captureUserMedia = (callback, options) => {
        let params = null;
        if (options) {
            params = options;
        } else {
            params = {audio: true, video: false};
        }

        navigator.mediaDevices.getUserMedia(params)
            .then(callback)
            .catch(error => {
                this.setState({result:false});
                console.log(error);
            });
    };

    render(){
        return(
            <div>
                <div className="row">
                    <div style={{width:300, marginLeft:'auto',marginRight:'auto', display:'flex'}}>
                        <div>
                            <img src={icon_microphone} style={{position:'relative',marginBottom:-5,width:65, height: 70}}/>
                        </div>
                        <div style={{marginTop:18, marginLeft:5}}>
                            <h3>Check Microphone</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={"col-md-6 col-sm-6"}>
                        {this.state.audioState!=3?
                        <div style={{marginTop: 100, marginLeft: 50}}>
                            <p>1. Click the 'Check' button.</p>
                            <p>2. Click 'Allow' if you see a question <br/>
                                in a dialog box.</p>
                            <p>3. Recording will start in a few seconds.<br/>
                                You can Stop anytime.</p>
                        </div>:
                            <div style={{marginTop: 100, marginLeft: 50}}>
                                <p>Press the Play button  to hear yourself.</p>
                            </div>
                        }
                    </div>
                    <div className={"col-md-6 col-sm-6"}>
                        <div>
                            <div style={{
                                marginTop: 100,
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: 290}}>
                                <audio ref={audio => {
                                    this.audio = audio
                                }}/>
                                <audio
                                    hidden={this.state.audioState!==3}
                                    controls={true}
                                    ref={audio2 => {
                                        this.audio2 = audio2
                                    }}
                                />
                            </div>
                        {this.state.audioState === 0 ?
                            <div style={{marginTop: 185, marginLeft: 'auto', marginRight: 'auto', width: 80}}>
                                <a className="handBtn" onClick={this.handleClickCheck}><span>Check</span></a>
                            </div> :null}


                        {this.state.audioState===2 ?
                            <div>
                                <div style={{
                                    marginTop: 140,
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    width: 320,
                                    height: 220
                                }}>
                                <div className="rec" style={{position:'relative',top:-20, fontSize:24, marginLeft:90}}><img src={recButton} className="ico-xs" /> RECORDING </div>

                                <div style={{marginTop: 20, marginLeft: 'auto', marginRight: 'auto', width: 80}}>
                                    <a className="handBtn" onClick={this.handleStop}><span>Stop</span></a>
                                </div>
                                </div>
                            </div>:
                                null
                        }
                            {this.state.audioState===3?
                            <div style={{ marginTop:160}}>
                                <div style={{marginTop: -135, marginLeft: 'auto', marginRight: 'auto', width: 80}}>
                                    <a className="handBtn" onClick={this.handleNext}><span>Next</span></a>
                                </div>
                            </div>:null}
                        </div>
                    </div>
                </div>
                <div className="row">
                </div>
            </div>
        )
    };
}

class TrafficLightComponent extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div>
                {this.props.networkStatus===NETWORK_STATUS.UNKNOWN?
                    <div>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
                {this.props.networkStatus===NETWORK_STATUS.CHECKING?
                    <div>
                        <img src={icon_trafficlight_yellow} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_yellow} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_yellow} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
                {this.props.networkStatus===NETWORK_STATUS.POOR?
                    <div>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
                {this.props.networkStatus===NETWORK_STATUS.ACCEPTABLE?
                    <div>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
                {this.props.networkStatus===NETWORK_STATUS.GOOD?
                    <div>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_empty} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
                {this.props.networkStatus===NETWORK_STATUS.EXCELLENT?
                    <div>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                        <img src={icon_trafficlight_green} style={{position:'relative',width:45, height: 50, marginTop: 20, marginLeft: 3, marginRight:3}}/>
                    </div>:null
                }
            </div>
        )
    }
}

class NeedsAssessmentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: STEP.HAS_CAMERA,
            hasWebCamera: false,
            passedWebCameraTest: false,
            hasMicrophone: false,
            passedMicrophoneTest: false,
            networkStatus: -2, //-2: unknown, -1: checking, 0: poor, 1: acceptable, 2: good, 3: excellent
            networkSpeed: 0,
            networkResult: "",
            availableApps: "",
            analytics: {
                type: null,
                metadata: null,
            }
        };

        this.handleBack = this.handleBack.bind(this);
        this.handleHasWebCamera = this.handleHasWebCamera.bind(this);
        this.handleHasNotWebCamera = this.handleHasNotWebCamera.bind(this);
        this.handleHasMicrophone = this.handleHasMicrophone.bind(this);
        this.handleHasNotMicrophone = this.handleHasNotMicrophone.bind(this);
        this.handleStartTestNetwork = this.handleStartTestNetwork.bind(this);
        this.handleDoneTestNetwork = this.handleDoneTestNetwork.bind(this);
        this.handleCreateAccount = this.handleCreateAccount.bind(this);
        this.getAvailableApps = this.getAvailableApps.bind(this);
        this.handleCheckVideo = this.handleCheckVideo.bind(this);
        this.handleStopVideoSuccess = this.handleStopVideoSuccess.bind(this);
        this.handleStopVideoFailure = this.handleStopVideoFailure.bind(this);
        this.handleCheckAudio = this.handleCheckAudio.bind(this);
        this.handleStopAudioSuccess = this.handleStopAudioSuccess.bind(this);
        this.handleStopAudioFailure = this.handleStopAudioFailure.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    componentDidMount() {
        //this.setState({currentStep: STEP.CHECK_AUDIO});
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleBack(){
        this.props.history.push("/resources");
    }

    handleHasWebCamera(){
        this.setState({hasWebCamera: true, currentStep: STEP.HAS_MICROPHONE});
    }

    handleHasNotWebCamera(){
        this.setState({hasWebCamera: false, currentStep: STEP.HAS_MICROPHONE});
    }

    handleHasMicrophone(){
        this.setState({hasMicrophone: true, currentStep: STEP.CHECK_NETWORK});
    }

    handleHasNotMicrophone(){
        this.setState({hasMicrophone: false, currentStep: STEP.CHECK_NETWORK});
    }

    async handleStartTestNetwork(){
        let currentSpeed = await Helpers.getNetworkUploadSpeed();

        this.setState({currentStep: STEP.CHECKING_NETWORK});
        setTimeout(async ()=>{
            const baseUrl = 'https://cors-anywhere.herokuapp.com/https://uploaddev.s3.us-east-2.amazonaws.com/content/network/50000000?version='+Math.random();
            const fileSizeInBytes = 50000000;
            //const speed = await testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
            //let networkSpeed = Math.round(speed.mbps/25)/10;
            const networkSpeed = currentSpeed.mbps;
            let networkStatus;
            let networkResult;
            if(networkSpeed >= NETWORK_SPEED.POOR && networkSpeed < NETWORK_SPEED.ACCEPTABLE){
                networkStatus = NETWORK_STATUS.POOR;
                networkResult = NETWORK_STATUS_STRING.POOR;
            }else if(networkSpeed >= NETWORK_SPEED.ACCEPTABLE && networkSpeed < NETWORK_SPEED.GOOD){
                networkStatus = NETWORK_STATUS.ACCEPTABLE;
                networkResult = NETWORK_STATUS_STRING.ACCEPTABLE;
            }else if(networkSpeed >= NETWORK_SPEED.GOOD && networkSpeed < NETWORK_SPEED.EXCELLENT){
                networkStatus = NETWORK_STATUS.GOOD;
                networkResult = NETWORK_STATUS_STRING.GOOD;
            }else if(networkSpeed >= NETWORK_SPEED.EXCELLENT){
                networkStatus = NETWORK_STATUS.EXCELLENT;
                networkResult = NETWORK_STATUS_STRING.EXCELLENT;
            }else {
                networkStatus = NETWORK_STATUS.UNKNOWN;
                networkResult = NETWORK_STATUS_STRING.UNKNOWN;
            }
            this.setState({
                currentStep: STEP.NETWORK_RESULT,
                networkSpeed: networkSpeed,
                networkStatus: networkStatus,
                networkResult: networkResult
            })
        },10);
    }
    async handleDoneTestNetwork(){
        this.getAvailableApps();
        await this.setState({
            analytics: {
                type: TRACKING.TECH_CHECK,
                metadata: {
                    hasWebCamera: this.state.hasWebCamera,
                    hasMicrophone: this.state.hasMicrophone,
                    networkSpeed: this.state.networkSpeed + 'MBPS',
                    availableApps: this.state.available
                }
            }
        });
        this.handleAnalytics();
        this.setState({
            currentStep: STEP.FINAL_RESULT
        });
    }
    handleCreateAccount(){
        this.props.history.push("/request-account");
    }
    async getAvailableApps(){
        let availableApps = "1.Slash 2.Maze 3.WordMark ";
        let appsNo = 4;
        if(this.state.hasMicrophone && this.state.networkStatus >= NETWORK_STATUS.ACCEPTABLE){
            availableApps = availableApps + appsNo + ".KidSpeak ";
            appsNo++;
        }
        if(this.state.hasWebCamera && this.state.networkStatus >= NETWORK_STATUS.ACCEPTABLE){
            availableApps = availableApps + appsNo + ".CopyRight ";
            appsNo++;
            availableApps = availableApps + appsNo + ".KidSign ";
            appsNo++;
            availableApps = availableApps + appsNo + ".PictureNaming ";
            appsNo++;
            availableApps = availableApps + appsNo + ".WordSign/Say ";
        }

        await this.setState({availableApps: availableApps});

    }
    handleCheckVideo(){
        this.setState({currentStep: STEP.CHECK_VIDEO});
    }
    handleStopVideoSuccess(){
        this.setState({currentStep: STEP.CHECK_AUDIO,
            passedWebCameraTest: true
        });
    }
    handleStopVideoFailure(){
        this.setState({currentStep: STEP.CHECK_AUDIO,
            passedWebCameraTest: false
        });
    }
    handleCheckAudio(){
        this.setState({currentStep: STEP.CHECK_VIDEO});
    }
    handleStopAudioSuccess(){
        this.setState({currentStep: STEP.VIDEO_AUDIO_RESULT,
            passedMicrophoneTest: true
        });
    }
    handleStopAudioFailure(){
        this.setState({currentStep: STEP.VIDEO_AUDIO_RESULT,
            passedMicrophoneTest: false
        });
    }

    render() {
        return (
            <div className="bgGrey CopyRight">
                <div>
                    <div className="appSection bgGrey">
                        <div className="section">
                            <div className="container">
                                <div className="row">
                                    <div className="appContainer copyright">
                                        {this.state.currentStep >= STEP.HAS_CAMERA && this.state.currentStep <= STEP.FINAL_RESULT ?
                                        <div className="row">
                                            <div className="col-md-3 col-sm-3"></div>
                                            <div className="col-md-6 col-sm-6 text-center">
                                                {this.state.currentStep >= STEP.HAS_CAMERA && this.state.currentStep <= STEP.FINAL_RESULT ?
                                                    <div style={{marginTop: 60}}>
                                                        <h2>Check your devices</h2>
                                                    </div>:null
                                                }
                                                {this.state.currentStep === STEP.HAS_CAMERA?
                                                    <div>
                                                        <div style={{marginTop: 20}}>
                                                            <img src={icon_person} style={{position:'relative',marginBottom:-5,width:65, height: 70}}/>
                                                        </div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>Do you have a webcam?</h1>
                                                            <p>Some apps use videos</p>
                                                        </div>
                                                        <div style={{marginTop: 40}}>
                                                            <a className="handBtn" onClick={this.handleHasWebCamera}><span>Yes</span></a>
                                                            <a className="handBtn" onClick={this.handleHasNotWebCamera}><span>No</span></a>
                                                        </div>
                                                    </div>: null
                                                }
                                                {this.state.currentStep === STEP.HAS_MICROPHONE?
                                                    <div>
                                                        <div style={{marginTop: 20}}>
                                                            <img src={icon_microphone} style={{position:'relative',marginBottom: -5,width:65, height: 70}}/>
                                                        </div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>Do you have a microphone?</h1>
                                                            <p>Some apps use audios</p>
                                                        </div>
                                                        <div style={{marginTop: 40}}>
                                                            <a className="handBtn" onClick={this.handleHasMicrophone}><span>Yes</span></a>
                                                            <a className="handBtn" onClick={this.handleHasNotMicrophone}><span>No</span></a>
                                                        </div>
                                                    </div>: null
                                                }
                                                {this.state.currentStep === STEP.CHECK_NETWORK?
                                                    <div>
                                                        <div style={{marginTop: 20}}>
                                                            <TrafficLightComponent networkStatus={NETWORK_STATUS.UNKNOWN} />
                                                        </div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>Check Internet Speed</h1>
                                                            <p>Click "Start" to start test.</p>
                                                        </div>
                                                        <div style={{marginTop: 40}}>
                                                            <a className="handBtn" onClick={this.handleStartTestNetwork}><span>Start</span></a>
                                                        </div>
                                                    </div>: null
                                                }
                                                {this.state.currentStep === STEP.CHECKING_NETWORK?
                                                    <div>
                                                        <div style={{marginTop: 20}}>
                                                            <TrafficLightComponent networkStatus={NETWORK_STATUS.CHECKING} />
                                                        </div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>Checking Internet Speed</h1>
                                                            <p>Wait...</p>
                                                        </div>
                                                    </div>: null
                                                }
                                                {this.state.currentStep === STEP.NETWORK_RESULT?
                                                    <div>
                                                        <div style={{marginTop: 20}}>
                                                            <TrafficLightComponent networkStatus={this.state.networkStatus} />
                                                        </div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>{this.state.networkSpeed=='Infinity'?"":this.state.networkSpeed+" Mbps"} </h1>
                                                            <p>Your Internet speed is {this.state.networkResult}!</p>
                                                        </div>
                                                        <div style={{marginTop: 40}}>
                                                            <a className="handBtn" onClick={this.handleDoneTestNetwork}><span>Done</span></a>
                                                        </div>
                                                    </div>: null
                                                }
                                                {this.state.currentStep === STEP.FINAL_RESULT?
                                                    <div>
                                                        <div style={{marginTop: 30}}>
                                                            <h1>Congratulations.</h1>
                                                            <p>You can use the following AvenuePM tasks:</p>
                                                            <h3>{this.state.availableApps}</h3>
                                                        </div>
                                                        <div style={{marginTop: 40}}>
                                                            <a className="handBtn" onClick={this.handleCreateAccount}><span>Create an Account</span></a>
                                                        </div>
                                                    </div>: null
                                                }
                                            </div>
                                            <div className="col-md-3 col-sm-3"></div>
                                        </div>:
                                            <div className="row">
                                                {this.state.currentStep === STEP.CHECK_VIDEO?
                                                    <CheckVideoComponent handleStopSuccess={this.handleStopVideoSuccess} handleStopFailure={this.handleStopVideoFailure}/>: null
                                                }
                                                {this.state.currentStep === STEP.CHECK_AUDIO?
                                                    <CheckAudioComponent handleStopSuccess={this.handleStopAudioSuccess} handleStopFailure={this.handleStopAudioFailure}/>: null
                                                }
                                                {this.state.currentStep === STEP.VIDEO_AUDIO_RESULT?
                                                    <div className="row">
                                                        <div className="row" style={{marginTop:140, marginLeft:'auto', marginRight:'auto', width:300}}>
                                                            {this.state.passedWebCameraTest?<h3>Video is working.</h3>
                                                                :<h3>Video is not working.</h3>
                                                            }
                                                        </div>
                                                        <div className="row" style={{marginTop:0, marginLeft:'auto', marginRight:'auto', width:300}}>
                                                            {this.state.passedMicrophoneTest?<h3>Audio is working.</h3>
                                                                :<h3>Audio is not working.</h3>
                                                            }
                                                        </div>
                                                        <div className="row" style={{marginTop:40, marginLeft:'auto', marginRight:'auto', width:500}}>
                                                            <p>If there are any problems, you can <a onClick={this.handleCheckVideo}>check video/audio again</a></p>
                                                        </div>
                                                    </div>: null
                                                }
                                            </div>
                                        }
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="section" style={{position:'relative', top:-40}}>
                        <div className="container">
                            <div className="row">
                                <div className="divBottomRelative tr">
                                    <div className={"col-md-3 col-sm-4"}>
                                        <a className="backArrow fl" onClick={this.handleBack} style={{width:60, height:60}}>
                                            <span style={{position:'relative', fontSize:32, marginLeft:20, top:17}}>Back</span>
                                        </a>
                                    </div>
                                    <div className={"col-md-9 col-sm-8"}>
                                        {this.state.currentStep===STEP.FINAL_RESULT?
                                            <div>
                                                <div style={{marginTop: 10, marginRight:0, float: 'right'}}>
                                                    <a className="handBtn" onClick={this.handleCheckVideo}><span>Check video/audio</span></a>
                                                </div>
                                                <div style={{marginTop:16, marginRight:10, float: 'right'}}>
                                                    <p>To use all apps, check video/audio is okay.</p>
                                                </div>
                                            </div>
                                            :null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(NeedsAssessmentComponent);


// WEBPACK FOOTER //
// ./src/NeedsAssessmentComponent/NeedsAssessment.js